import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";
import AddAttendance from "./AddAttendance";

class AttendanceList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      searchParam: "",

      filter: {
        employee: "",
        fromDate: "",
        toDate: "",
        status: ""
      },

      showFilter: false,
      showOption: false,
      showDelete: false,
      showAddAttendance: false,

      selectedRow: null,

      isFilterActive: false,

      listPageSettings: {

        Title: "Attendance",

        Search: {
          showSearch: true,
          placeholder: "Search by employee name",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
          onFilterClick: () => this.setState({ showFilter: true }),
          isFilterActive: false
        },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
          {
            ButtonType: "ImageButton",
            Type: "option",
            Text: "Options",
            Icon: "option",
            Action: "options"
          }
        ],

        Columns: [
          {
            Name: "Employee",
            Type: "field",
            Columns: [{ Column: "EmployeeDisplay" }],
          },
          {
            Name: "Date",
            Type: "field",
            Columns: [{ Column: "Date", Type: "date" }],
          },
          {
            Name: "Status",
            Type: "field",
            Columns: [{ Column: "AttendanceType" }],
          },
          {
            Name: "In Time",
            Type: "field",
            Columns: [{ Column: "InTimeDisplay" }],
          },
          {
            Name: "Out Time",
            Type: "field",
            Columns: [{ Column: "OutTimeDisplay" }],
          },
          {
            Name: "Remarks",
            Type: "field",
            Columns: [{ Column: "Remarks" }]
          },
          {
            Name: "Employee",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "EmployeeDisplay" },
              { Column: "Date", Type: "date" },
              { Column: "AttendanceType" },
              { Column: "InTimeDisplay", Label: "In Time" },
              { Column: "OutTimeDisplay", Label: "Out Time" },
              { Column: "Remarks" },
            ],
          },
        ],

        RowButtons: [
          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit"
          }
        ]

      }

    };

  }

  componentDidMount() {
    this.loadData();
  }

  // =====================
  // LOAD DATA
  // =====================

loadData = async () => {
  this.setState({ loading: true });

  try {
    const { page, pageSize, filter, searchParam } = this.state;

    const res = await this.props.getAttendance(
     
       this.props.user.store.key,// Made compulsory by removing default null value
 (page - 1) * pageSize,
      pageSize,
   filter.fromDate,
      filter.toDate,
 searchParam || filter.employee,
  filter.status

    );
    console.log("res",res);

    let list = [];
    let totalCount = 0;

    if (res && res.hasOwnProperty("attendance")) {
  list = res.attendance.map((data) => {
    let inTimeStr = "";
    let outTimeStr = "";

    if (
      data.AttendanceType !== "Leave" &&
      data.AttendanceType !== "Week-Off"
    ) {
      if (
        data.hasOwnProperty("InTime") &&
        data.InTime &&
        data.InTime.hasOwnProperty("HH")
      ) {
        inTimeStr =
          data.InTime.HH +
          ":" +
          data.InTime.MM +
          " " +
          data.InTime.AMPM;
      }

      if (
        data.hasOwnProperty("OutTime") &&
        data.OutTime &&
        data.OutTime.hasOwnProperty("HH")
      ) {
        outTimeStr =
          data.OutTime.HH +
          ":" +
          data.OutTime.MM +
          " " +
          data.OutTime.AMPM;
      }
    }

    return {
      ...data,
      InTimeDisplay: inTimeStr,
      OutTimeDisplay: outTimeStr,
      EmployeeDisplay:
        data.hasOwnProperty("Employee") &&
        data.Employee &&
        data.Employee.hasOwnProperty("label")
          ? data.Employee.label
          : ""
    };
  });
}

    if (res && res.hasOwnProperty("totalRecords")) {
      totalCount = res.totalRecords;
    }

    this.setState({
      list,
      totalCount,
      loading: false
    });
  } catch (error) {
    console.error(error);
    this.setState({
      loading: false
    });
  }
};
  // =====================
  // SEARCH
  // =====================

  onSearch = (text) => {

    this.setState({
      searchParam: text,
      page: 1
    }, this.loadData);

  };

  onRefreshClick = () => {

    this.setState({

      filter: {
        employee: "",
        fromDate: "",
        toDate: "",
        status: ""
      },

      page: 1,
      isFilterActive: false

    }, this.loadData);

  };

  // =====================
  // FILTER CHANGE
  // =====================

  onFilterChange = (key, value) => {

    this.setState({

      filter: {
        ...this.state.filter,
        [key]: value
      }

    });

  };

  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount / this.state.pageSize
    );

    if (this.state.page < totalPages) {

      this.setState({
        page: this.state.page + 1
      }, this.loadData);

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({
        page: this.state.page - 1
      }, this.loadData);

    }

  };

  onFirstClick = () => {

    this.setState({ page: 1 }, this.loadData);

  };

  onLastClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount / this.state.pageSize
    );

    this.setState({
      page: totalPages
    }, this.loadData);

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({
      pageSize: Number(size),
      page: 1
    }, this.loadData);

  };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.setState({
        showAddAttendance: true,
        selectedRow: null
      });

    }

    if (btn.Action === "options") {

      this.setState({
        showOption: true
      });

    }

  };

  // =====================
  // FILTER
  // =====================

  onApplyFilter = () => {

    this.setState({

      page: 1,
      showFilter: false,
      isFilterActive: true

    }, this.loadData);

  };

  onClearFilter = () => {

    this.onRefreshClick();

    this.setState({
      showFilter: false
    });

  };

  // =====================
  // ROW BUTTON
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.setState({
        showAddAttendance: true,
        selectedRow: row
      });

    }

  };

  // =====================
  // EXPORT
  // =====================

 getExportData = async () => {

  const { filter, searchParam } = this.state;

  this.setState({ loading: true });

  const res = await this.props.getAttendance(
    this.props.user.store.key,   // storeID (compulsory)
    0,                           // from
    10000,                        // size
    filter.fromDate,
    filter.toDate,
    searchParam || filter.employee,
    filter.status
  );

  this.setState({ loading: false });

  let list = [];

  if (res && res.hasOwnProperty("attendance") && Array.isArray(res.attendance)) {

    list = res.attendance.map((data) => {

      let inTimeStr = "";
      let outTimeStr = "";

      if (
        data.AttendanceType !== "Leave" &&
        data.AttendanceType !== "Week-Off"
      ) {

        if (
          data.hasOwnProperty("InTime") &&
          data.InTime &&
          data.InTime.hasOwnProperty("HH")
        ) {
          inTimeStr =
            data.InTime.HH +
            ":" +
            data.InTime.MM +
            " " +
            data.InTime.AMPM;
        }

        if (
          data.hasOwnProperty("OutTime") &&
          data.OutTime &&
          data.OutTime.hasOwnProperty("HH")
        ) {
          outTimeStr =
            data.OutTime.HH +
            ":" +
            data.OutTime.MM +
            " " +
            data.OutTime.AMPM;
        }

      }

      return {
        ...data,
        InTimeDisplay: inTimeStr,
        OutTimeDisplay: outTimeStr,
        EmployeeDisplay:
          data.hasOwnProperty("Employee") &&
          data.Employee &&
          data.Employee.hasOwnProperty("label")
            ? data.Employee.label
            : ""
      };

    });

  }

  return list;

};
  handleExport = async (type) => {

    this.setState({ loading: true });

    try {

      const data = await this.getExportData();

      if (!data.length) {

        alert("No data found");
        return;

      }

      const columns = [
        { header: "Employee", field: "EmployeeDisplay" },
        { header: "Date", field: "Date", type: "date" },
        { header: "Status", field: "AttendanceType" },
        { header: "In Time", field: "InTimeDisplay" },
        { header: "Out Time", field: "OutTimeDisplay" },
        { header: "Remarks", field: "Remarks" },
      ];

      await exportFile({

        data,
        columns,
        fileType: type,
        title: "Attendance",
        landscape: true

      });

    }
    catch (error) {

      console.error(error);
      alert("Export failed");

    }
    finally {

      this.setState({ loading: false });

    }

  };

  // =====================
  // POPUP EVENTS
  // =====================

  onPostPopupSave = () => {

    this.setState({

      showAddAttendance: false,
      selectedRow: null

    }, this.loadData);

  };

  onClosePopup = () => {

    this.setState({

      showAddAttendance: false,
      selectedRow: null

    });

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    const f = this.state.filter;

    return (

      <>

        <ListingPage

          {...this.props}
          onPageChange={this.onPageChange}

          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state.listPageSettings.Search,
              isFilterActive: this.state.isFilterActive

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}

          onHeaderButtonClicked={this.onHeaderButtonClicked}

          onRowButtonClicked={this.onRowButtonClicked}

        />

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide

            onClose={() => this.setState({ showFilter: false })}

            onButtonClick={(action) => {

              if (action.toLowerCase() === "apply") {
                this.onApplyFilter();
              }
              else if (action.toLowerCase() === "clear") {
                this.onClearFilter();
              }

            }}

            buttons={[

              { Type: "secondary", Text: "Clear", Align: "left" },
              { Type: "primary", Text: "Apply", Align: "right" }

            ]}

          >

            <Input
              type="text"
              label="Employee"
              value={f.employee}
              onChange={(v) => this.onFilterChange("employee", v)}
            />

            <Input
              type="date"
              label="From Date"
              value={f.fromDate}
              onChange={(v) => this.onFilterChange("fromDate", v)}
            />

            <Input
              type="date"
              label="To Date"
              value={f.toDate}
              onChange={(v) => this.onFilterChange("toDate", v)}
            />

            <Input
              type="select"
              label="Status"
              value={f.status}
              onChange={(v) => this.onFilterChange("status", v)}
            >

              <option value="">All</option>
              <option value="Present">Present</option>
              <option value="Half Day">Half Day</option>
              <option value="Leave">Leave</option>
              <option value="Week-Off">Week-Off</option>

            </Input>

          </Window>

        )}

        {this.state.showOption && (

          <Window

            header="Options" choiceList

            size="small"

            slide

            onClose={() => this.setState({ showOption: false })}

          >

            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "center",
                flexWrap: "wrap"
              }}
            >

              <ExportButton
                onExport={this.handleExport}
                loading={this.state.loading}
              />

            </div>

          </Window>

        )}

        {this.state.showAddAttendance && (

          <AddAttendance
            {...this.props}
            attendance={this.state.selectedRow}
            onSave={this.onPostPopupSave}
            onClose={this.onClosePopup}
          />

        )}

      </>

    );

  }

}

export default AttendanceList;